import React from "react";

export default function ModalEdit({ open, onClose, children }) {
  if (!open) return null;
  return (
    <div style={{
      position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
      background: "rgba(0,0,0,0.3)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000
    }}>
      <div style={{
        background: "#fff", padding: 24, borderRadius: 8, boxShadow: "0 2px 8px #0002", minWidth: 320
      }}>
        {children}
        <button onClick={onClose} style={{ marginTop: 16, padding: "8px 16px" }}>Close</button>
      </div>
    </div>
  );
}